const MINUTES_IN_HOUR = 60
const HOURS_IN_DAY = 24

// Длительность в минутах: «N мин», «N ч M мин», «N д M ч» — от суток минуты отбрасываем
export const formatMinutes = (minutes: number) => {
  if (minutes < 1) return 'меньше минуты'

  const hours = Math.floor(minutes / MINUTES_IN_HOUR)
  if (!hours) return `${minutes} мин`

  const restMinutes = minutes % MINUTES_IN_HOUR
  if (hours < HOURS_IN_DAY) {
    return [`${hours} ч`, restMinutes && `${restMinutes} мин`]
      .filter(Boolean)
      .join(' ')
  }

  const days = Math.floor(hours / HOURS_IN_DAY)
  const restHours = hours % HOURS_IN_DAY
  return [`${days} д`, restHours && `${restHours} ч`]
    .filter(Boolean)
    .join(' ')
}
